var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-gapless has-background-light bottom-controls"},[_c('div',{staticClass:"column"},[_c('records-info')],1),_c('div',{staticClass:"column is-narrow has-text-right"},[(_vm.hasEntries())?_c('pagination'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }